import { polymorphicFactory, Box, Spacer, Grid, GridColumn, Flex, Typography, omitText, Link, Button } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React, { isValidElement } from 'react';
import { ContentCard } from './subcomponents/ContentCard/ContentCard.mjs';
import classes from './TwoUpContent.module.css.mjs';
import { imagesAspectRatio, twoUpContentCardsWrapperClassName } from './TwoUpContent.utils.mjs';

const TwoUpContent = polymorphicFactory(
  (props, ref) => {
    const {
      component = "div",
      CTA,
      CTALink,
      type = "50-50",
      imageOrientation = "landscape",
      eyebrow,
      description,
      heading,
      mod,
      cards,
      topSpacer,
      bottomSpacer,
      className,
      ...rest
    } = props;
    const aspectRatio = imagesAspectRatio[type][imageOrientation];
    const isLandscape5050 = imageOrientation === "landscape" && type === "50-50";
    const isPortrait = imageOrientation === "portrait";
    return /* @__PURE__ */ React.createElement(
      Box,
      {
        mod,
        ...rest,
        className: clsx("kohler-two-up-content-root", classes.twoUpContentWrapper, className),
        component,
        ...rest,
        ref
      },
      topSpacer && /* @__PURE__ */ React.createElement(Spacer, { ...topSpacer }),
      /* @__PURE__ */ React.createElement(Grid, { className: "center-grid" }, isLandscape5050 && (eyebrow || heading || description || CTA || CTALink) && /* @__PURE__ */ React.createElement(GridColumn, { className: classes.twoUpContentHeaderContainer }, /* @__PURE__ */ React.createElement(Flex, { direction: "column", gap: 35 }, (eyebrow || heading) && /* @__PURE__ */ React.createElement(Flex, { direction: "column", gap: 10 }, eyebrow && /* @__PURE__ */ React.createElement(
        Typography,
        {
          component: isValidElement(eyebrow.text) ? "div" : eyebrow.component || "p",
          size: "label-medium-m",
          textColor: "var(--content-tertiary)",
          ...omitText(eyebrow)
        },
        eyebrow.text
      ), heading && /* @__PURE__ */ React.createElement(Typography, { textColor: "var(--content-primary)", component: heading.component || "h3", size: "h2", ...omitText(heading) }, heading.text)), description && /* @__PURE__ */ React.createElement(
        Typography,
        {
          textColor: "var(--content-secondary)",
          component: isValidElement(description.text) ? "div" : description.component || "p",
          size: "paragraph-large",
          ...omitText(description)
        },
        description.text
      )), (CTA || CTALink) && /* @__PURE__ */ React.createElement(Flex, { className: clsx(classes.twoUpContentButtonContainer, !CTALink && CTA && classes.twoUpContentButtonContainerCTA) }, CTALink && /* @__PURE__ */ React.createElement(Link, { ...omitText(CTALink), size: "large" }, CTALink.text), CTA && /* @__PURE__ */ React.createElement(
        Button,
        {
          component: "a",
          ...omitText(CTA),
          variant: "secondary",
          size: "large",
          className: classes.twoUpContentButtonContainerCTA
        },
        CTA.text
      ))), /* @__PURE__ */ React.createElement(
        GridColumn,
        {
          className: clsx(
            twoUpContentCardsWrapperClassName[type],
            classes.twoUpContentCardsContainer,
            isLandscape5050 && classes.twoUpContentCardsContainerLandscape
          )
        },
        cards && cards.slice(0, 2).map((card, index) => /* @__PURE__ */ React.createElement(ContentCard, { key: card.title?.text || index, ...card, aspectRatio: aspectRatio[index], isPortrait }))
      ), isLandscape5050 && CTA && /* @__PURE__ */ React.createElement(GridColumn, { className: classes.twoUpContentButtonBottomContainer }, /* @__PURE__ */ React.createElement(Button, { component: "a", ...omitText(CTA), fullWidth: true, variant: "secondary", size: "large" }, CTA.text))),
      bottomSpacer && /* @__PURE__ */ React.createElement(Spacer, { ...bottomSpacer })
    );
  }
);

export { TwoUpContent };
